// @flow

export default {
  _aws: ['node 8.1'],
  _azure: ['node 8.11', 'node 10.6'],
  _google: ['node 8.11'],
  latest: ['node 10'],
  maintenance: ['node 8', 'node 10'],
  next: ['node 10'],
};
